import { postMessage, getTokenFromIframe } from '@/utils/iframeMessage'
import { ClientAuth } from 'byt-wx-login/oidc-client'
import store from '@/store'

const oa = new ClientAuth({
  authority: window.domainConfig.ssoSite, // sso站点 根据环境配置
  client_id: process.env.NODE_ENV === 'development' ? 'jsEvosClient' : 'evosClient',
  customLogin: () => {
    // 监听到有退出操作，跳转到指定的URL，由调用方根据业务需求决定
    console.log('go login')
    window.location.reload()
  },
  baseUrl: '/formrender/'
})

// export const getUserProfile = oa.getUserProfile.bind(oa)

export const getUserProfile = async () => {
  if (store.getState().st === 'y' && window.self !== window.top) {
    postMessage({ type: 'getUserInfo' })
    return getTokenFromIframe({ type: 'userInfo' })
  }
  return oa.getUserProfile()
}
export const userSigninPopup = async () => {
  if (store.getState().st === 'y' && window.self !== window.top) {
    postMessage({ type: 'token' })
    const token = await getTokenFromIframe().catch(() => {})
    return { token, code: 1 }
  }
  return oa.userSigninPopup()
}
export const userSignoutPopup = oa.userSignoutPopup.bind(oa)

export function getToken() {
  if (store.getState().st === 'y') {
    postMessage({ type: 'token' })
    return getTokenFromIframe()
  }
  return oa.getToken()
}
